import { referralActionTypes } from '../actions/types';

const initialState = {
  referredList: [],
  status: null,
};

export function referral(state = initialState, action) {
  switch (action.type) {
    case referralActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case referralActionTypes.FETCH_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        status: 'loaded',
        referredList: action.referredList,
        error: null,
      };
    case referralActionTypes.FETCH_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    default:
      return state;
  }
}
